// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textSwitch {
    border-radius: 20px;
    background-color: "#818181";
    opacity: 1 !important;
    &:after, &:before: {
        color: "white";
        font-size: "11px";
        position: "absolute";
        top: "6px";
    }
}

.andOrSwitch::before {
    content: 'and';
    left: 8px;;
}

.andOrSwitch::after {
    content: 'or';
    right: 7px;
}
`, "",{"version":3,"sources":["webpack://./src/components/search/QueryBuilderComponent.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,qBAAqB;IACrB;QACI,cAAc;QACd,iBAAiB;QACjB,oBAAoB;QACpB,UAAU;IACd;AACJ;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,UAAU;AACd","sourcesContent":[".textSwitch {\r\n    border-radius: 20px;\r\n    background-color: \"#818181\";\r\n    opacity: 1 !important;\r\n    &:after, &:before: {\r\n        color: \"white\";\r\n        font-size: \"11px\";\r\n        position: \"absolute\";\r\n        top: \"6px\";\r\n    }\r\n}\r\n\r\n.andOrSwitch::before {\r\n    content: 'and';\r\n    left: 8px;;\r\n}\r\n\r\n.andOrSwitch::after {\r\n    content: 'or';\r\n    right: 7px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
